import { TbBug, TbGalaxy, TbGhost, TbMicrophone, TbTrash } from "react-icons/tb";
import { Dropdown } from "react-bootstrap";
import Markdown from "./Markdown";
import { BiPlus } from "react-icons/bi";
import { CiGlobe } from "react-icons/ci";


const MainChat = ({ isSidebarClosed, chats, fetchChat, setChatMessages, chatId, setChatId, fetchActions, actions, formatTimestamp, chatMessages, isSending, inputValue, newMexId, thinking, setInputValue, chatEndRef, handleSend, handleKeyDown, handleDeleteClick, setSelectedRecordId, setLoadingActions, loadingActions, handleMicClick, microphoneOn, context }) => {

    return (
        <div
            className={`main_codespaces_cont_chat ${isSidebarClosed ? "main_codespaces_cont_chat_closed" : ""
                } fade-in`}
        >
            <div className="main_codespaces_cont_chat_content">

                <div className="chat_container_ai_header">
                    <div className="chat_dropdown_container">


                        <Dropdown>
                            <div className="property_btn_action_toggle">
                                <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                    <button className="newchat_chat_btn">
                                        {chatId
                                            ? chats.find((c) => c._id === chatId)?.chat_name
                                            : "New Chat"}
                                    </button>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="custom-dropdown-menu">
                                    <Dropdown.Item
                                        className="drop_down_item"
                                        onClick={() => (setChatId(null), setChatMessages([]))}
                                    >
                                        New Chat
                                    </Dropdown.Item>

                                    {chats.map((chat) => (
                                        <Dropdown.Item
                                            key={chat._id}
                                            className="drop_down_item d-flex justify-content-between align-items-center"
                                        >
                                            <span
                                                className="chat_name"
                                                onClick={() => {
                                                    setChatId(chat._id);
                                                    fetchChat(chat._id);
                                                }}
                                            >
                                                {chat.chat_name}
                                            </span>
                                            <button
                                                className="delete_chat_btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedRecordId(chat._id)
                                                    handleDeleteClick(chat);
                                                }}
                                            >
                                                <TbTrash />
                                            </button>
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </div>
                        </Dropdown>

                    </div>
                </div>


                <div className="chat_container_ai_mex">
                    {chatMessages.length === 0 && chatId == null ? (
                        <div className="empty_chat_container">
                            <div className="empty_chat">
                                <p className="empty_chat_title">
                                    Start a conversation with ErioonAI
                                </p>
                                <p className="empty_chat_subtitle">
                                    Erioon can handle anything you need: from creating
                                    databases and collections, writing and deploying code,
                                    running and testing it and beyond.
                                </p>
                            </div>
                        </div>
                    ) : (
                        chatMessages.map((msg, i) => (
                            <>
                                <div
                                    key={i}
                                    className={
                                        msg.role === "assistant"
                                            ? "chat_message_ai_cont fade-in"
                                            : "chat_message_user_cont fade-in"
                                    }
                                >
                                    <div
                                        className={
                                            msg.role === "assistant"
                                                ? "chat_message_ai fade-in"
                                                : "chat_message_user fade-in"
                                        }
                                    >
                                        {msg.role === "assistant" ? (
                                            <>
                                                {msg.content ? (
                                                    <Markdown msg={msg} newMexId={newMexId} chatEndRef={chatEndRef} />

                                                ) : (
                                                    i === chatMessages.length - 1 && (
                                                        thinking && (
                                                            <div className="thinking_message">

                                                                <div className="thinking_message_header">
                                                                    <i className="logo_rotating">
                                                                        <TbGalaxy />
                                                                    </i>
                                                                    <p className="thinking_message_p fade-in">Thinking</p>

                                                                </div>

                                                            </div>
                                                        )
                                                    )
                                                )}


                                                <div className="chat_timestamp">
                                                    {formatTimestamp(msg.timestamp)}
                                                    {(i === chatMessages.length - 1 && msg.role === "assistant" && msg.content) && (
                                                        // <button
                                                        //     className="live_actions_btn"
                                                        //     onClick={() => {
                                                        //         setLoadingActions(true);
                                                        //         fetchActions();
                                                        //         setTimeout(() => setLoadingActions(false), 2000);
                                                        //     }}
                                                        // >
                                                        //     <i className={`fa-solid fa-rotate ${loadingActions ? "loading_notification" : ""}`}></i> Live actions
                                                        // </button>
                                                        <>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="user_msg">
                                                    {msg.content}
                                                </div>
                                                <div className="chat_timestamp">
                                                    {formatTimestamp(msg.timestamp)}
                                                </div>
                                            </>
                                        )}


                                    </div>
                                </div>
                                {i === chatMessages.length - 1 && actions.length > 0 && (
                                    <div className="actions_container_ai_main">

                                        <div className="actions_container_ai">
                                            <p className="actions_container_ai_title">Live actions</p>
                                            {actions.map((actionText, i) => {
                                                return (
                                                    <div className="single_action_card fade-in"
                                                        dangerouslySetInnerHTML={{ __html: actionText }}></div>
                                                );
                                            })}

                                        </div>

                                    </div>
                                )}
                                <div ref={chatEndRef}></div>
                            </>

                        ))
                    )}
                    <div />
                </div>

                <div className="main_codespace_chat_footer">
                    <div className="input_chat_ai_container">
                        <div className="input_chat_ai_container_top">
                            <textarea
                                className="input_chat_ai"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                onKeyDown={handleKeyDown}
                                disabled={isSending}
                                placeholder="Type your message..."
                                style={{ resize: "none", overflowY: "auto" }}
                            />
                        </div>
                        <div className="bottom_ai_chat_items">
                            <div className="bottom_ai_chat_items_btns_cont">
                                {/* <button className="bottom_ai_chat_items_btn"><BiPlus /></button> */}
                                {/* <button className="bottom_ai_chat_items_btn"><CiGlobe /></button> */}
                                <button className={`bottom_ai_chat_items_btn ${microphoneOn ? "bottom_ai_chat_items_btn_selected" : ""}`} onClick={handleMicClick}><TbMicrophone /></button>
                            </div>


                            <div className="button_chat_ai_container">
                                <button
                                    className="button_chat_ai"
                                    onClick={handleSend}
                                    disabled={isSending}
                                >
                                    <i className="fa-solid fa-arrow-up"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="ai_warning_chat_cont">
                        <p>
                            Erioon AI may generate inaccurate or incomplete information.
                            Please verify important details.
                        </p>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default MainChat;
